import { DateTime } from 'luxon'

const datetimeToStartOrEndDatetime = (date: Date, start = true): DateTime => {
    const datetime = DateTime.fromJSDate(date)
    const { year, month, day } = datetime
    const hour = start ? 0 : 23
    const minute = start ? 0 : 59
    const second = start ? 0 : 59
    const millisecond = start ? 0 : 999

    return DateTime.fromObject({
        year,
        month,
        day,
        hour,
        minute,
        second,
        millisecond
    })
}

export default datetimeToStartOrEndDatetime
